import React, { useCallback, useEffect, useState } from 'react';

import PixelMind from './labs/PixelMind_raw';

export default function ImageInsightsHub({ onBack }) {
  // PixelMind manages its own state, but only reads `experiment` on first mount.
  // We keep an experiment object here mainly to support "reset" and future persistence.
  const [experiment, setExperiment] = useState(() => ({ pixelMindImages: [] }));
  const [mountSeed, setMountSeed] = useState(1);

  const onUpdate = useCallback((patch) => {
    if (!patch || typeof patch !== 'object') return;
    setExperiment((prev) => ({ ...(prev || {}), ...patch }));
  }, []);

  const reset = useCallback(() => {
    setExperiment({ pixelMindImages: [] });
    setMountSeed((s) => s + 1);
  }, []);

  useEffect(() => {
    const onNew = () => reset();
    window.addEventListener('dd:image_insights:new', onNew);
    return () => window.removeEventListener('dd:image_insights:new', onNew);
  }, [reset]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: 0 }}>
      {/* Keep the hub wrapper minimal; PixelMind already provides its own UI. */}
     

      <div style={{ minHeight: 0 }}>
        <PixelMind key={mountSeed} experiment={experiment} onUpdate={onUpdate} />
      </div>
    </div>
  );
}

